__turbopack_context__.v({
  "icon_btn": "vGeaEa_icon_btn",
  "supportLink": "vGeaEa_supportLink",
  "toggle_btn": "vGeaEa_toggle_btn",
});
